import { render } from "./Mb036.vue?vue&type=template&id=5c017cc8"
import script from "./Mb036.vue?vue&type=script&lang=js"
export * from "./Mb036.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__